import { useCallback, useRef, useState } from "react";

// 通用异步 hook
export function useAsyncAction() {
  const [isProcessing, setProcessing] = useState(false);
  const isProcessingRef = useRef(false);

  const run = useCallback(
    async (fn: () => Promise<any>) => {
      // 🔴 修复严重问题：使用 ref 来检查状态，避免 useCallback 依赖导致的无限重创建
      // 问题：当 isProcessing 作为依赖项时，每次状态改变都会重新创建 run 函数
      // 导致：上层组件的回调函数无限重创建，最终阻塞了正常的搜索流程
      if (isProcessingRef.current) {
        return;
      }
      isProcessingRef.current = true;
      setProcessing(true);
      try {
        await fn();
      } finally {
        // 为了避免逻辑执行完成而页面渲染未更新，设置 1s 的延迟
        setTimeout(() => {
          isProcessingRef.current = false;
          setProcessing(false);
        }, 1000);
      }
    },
    [], // 🔴 关键修复：移除 isProcessing 依赖，使用空依赖数组确保函数稳定
  );
  return { isProcessing, run };
}
